import { getCourseLanguage } from '@/data/languages';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Learner registration - creates or fetches existing learner by name
export const registerLearner = async (name) => {
  try {
    const res = await axios.post(`${API}/learners`, { name });
    localStorage.setItem('learnerId', res.data.id);
    localStorage.setItem('studentName', res.data.name);
    return res.data;
  } catch (e) {
    console.error('registerLearner error:', e);
    return null;
  }
};

export const getLearnerId = () => localStorage.getItem('learnerId');

// Log an activity (quiz or lesson) — awards badges automatically on backend
export const logActivity = async (type, referenceId, score = null, total = null, timeTakenSec = null, language = getCourseLanguage()) => {
  const learnerId = getLearnerId();
  if (!learnerId) return null;
  try {
    const res = await axios.post(`${API}/learners/${learnerId}/activity`, {
      type,
      reference_id: referenceId,
      score,
      total,
      time_taken_sec: timeTakenSec,
      language,
    });
    // Show toasts for newly earned badges
    if (res.data.newly_earned_badges?.length > 0) {
      res.data.newly_earned_badges.forEach(b => {
        toast.success(`🏅 Badge Unlocked: ${b.badge_name}!`, {
          description: 'View it in your Badges page.',
          duration: 5000,
        });
      });
    }
    return res.data;
  } catch (e) {
    console.error('logActivity error:', e);
    return null;
  }
};

export const getBadges = async () => {
  const learnerId = getLearnerId();
  if (!learnerId) return [];
  try {
    const res = await axios.get(`${API}/learners/${learnerId}/badges`);
    return res.data;
  } catch (e) {
    return [];
  }
};

export const getActivities = async () => {
  const learnerId = getLearnerId();
  if (!learnerId) return [];
  try {
    const res = await axios.get(`${API}/learners/${learnerId}/activities`);
    return res.data;
  } catch (e) {
    return [];
  }
};

// Admin API
export const adminLogin = async (username, password) => {
  try {
    const res = await axios.post(`${API}/admin/login`, { username, password });
    localStorage.setItem('adminToken', res.data.token);
    return res.data;
  } catch (e) {
    return null;
  }
};

export const getAdminToken = () => localStorage.getItem('adminToken');

export const adminLogout = () => {
  localStorage.removeItem('adminToken');
};

const adminHeaders = () => ({ headers: { Authorization: `Bearer ${getAdminToken()}` } });

export const adminGetLearners = async () => {
  try {
    const res = await axios.get(`${API}/admin/learners`, adminHeaders());
    return res.data;
  } catch (e) {
    return [];
  }
};

export const adminGetLearnerDetail = async (learnerId) => {
  try {
    const res = await axios.get(`${API}/admin/learners/${learnerId}/detail`, adminHeaders());
    return res.data;
  } catch (e) {
    return null;
  }
};

export const adminGetAnalytics = async () => {
  try {
    const res = await axios.get(`${API}/admin/analytics`, adminHeaders());
    return res.data;
  } catch (e) {
    return null;
  }
};

export const adminReissueCertificate = async (learnerId, badgeId) => {
  try {
    const res = await axios.post(
      `${API}/admin/learners/${learnerId}/reissue-cert/${badgeId}`,
      {},
      adminHeaders()
    );
    return res.data;
  } catch (e) {
    return null;
  }
};
